import { CheckName } from 'lib/verificationCheck';

export { CheckName };

export enum CheckStatus {
  Passed = 'passed',
  Failed = 'failed',
  NotApplicable = 'not_applicable',
}

export enum CheckCategory {
  Fraud = 'fraud',
  UserActionRequired = 'user_action_required',
  Validity = 'validity',
  Biometrics = 'biometrics',
}

export enum CheckAttributeMatch {
  Full = 'full',
  Partial = 'partial',
  None = 'none',
  Missing = 'missing',
}

// app/models/verification/check.rb
export enum MatchRequirement {
  Required = 'required',
  NotRequired = 'not_required',
  RequiresRetry = 'requires_retry',
}

export enum CheckReasonNotApplicable {
  Disabled = 'disabled',
  DisabledByCheckConfig = 'disabled_by_check_config',
}
export interface CheckReason {
  name: string;
  info: Record<string, unknown>; // TODO: fix this
}

export interface DisabledReason {
  name: CheckReasonNotApplicable.Disabled;
  info: unknown; // TODO: fix this
}

export type BaseCheck<
  N extends CheckName,
  ReasonsPassed,
  ReasonsFailed,
  ReasonsNotApplicable,
  Metadata,
> = {
  name: N;
  status: CheckStatus;
  reasons: (ReasonsPassed | ReasonsFailed | ReasonsNotApplicable)[];
  requirement: MatchRequirement;
  // TODO: fix this, not sure if accurate - ie is it possible for metadata to return an empty object?
  readonly metadata?: Metadata | Record<string, never>;
  'redacted-at'?: string;
};
